// src/components/Dashboard/LogsTable.js
import React, { useState } from "react";

export default function LogsTable({ data }) {
    const logs = Array.isArray(data?.data) ? data.data : [];
    const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (index) => {
        setExpandedRows((prev) => ({
            ...prev,
            [index]: !prev[index],
        }));
    };

    const getLevelColor = (level) => {
        switch (level) {
            case "ERROR":
                return "bg-red-50 text-red-500";
            case "WARN":
                return "bg-yellow-50 text-yellow-500";
            case "INFO":
                return "bg-green-50 text-green-500";
            default:
                return "bg-gray-50 text-gray-500";
        }
    };

    const formatTimestamp = (ts) => {
        try {
            return new Date(ts).toLocaleString();
        } catch {
            return ts;
        }
    };

    return (
        <div className="bg-white rounded-2xl p-5 shadow-md border border-orange-300 hover:shadow-orange-400/40 transition-all duration-300">
            <h2 className="text-lg font-semibold mb-4 text-orange-600">
                Application Logs
            </h2>

            <div className="overflow-y-auto max-h-[500px] border rounded-md">
                <table className="w-full text-sm border-collapse">
                    <thead className="bg-orange-50 text-orange-600 sticky top-0 z-10">
                        <tr>
                            <th className="text-left py-2 px-3 border-b border-orange-200">Time</th>
                            <th className="text-left py-2 px-3 border-b border-orange-200">Level</th>
                            <th className="text-left py-2 px-3 border-b border-orange-200">Message</th>
                            <th className="text-left py-2 px-3 border-b border-orange-200">Exception</th>
                        </tr>
                    </thead>
                    <tbody>
                        {logs.length > 0 ? (
                            logs.map((log, i) => (
                                <React.Fragment key={i}>
                                    <tr
                                        className={`cursor-pointer hover:bg-orange-50 transition-colors duration-200`}
                                        onClick={() => toggleRow(i)}
                                    >
                                        <td className="py-2 px-3 text-gray-700">
                                            {formatTimestamp(log.timeStamp)}
                                        </td>
                                        <td className={`py-2 px-3 font-semibold ${getLevelColor(log.level)}`}>
                                            {log.level}
                                        </td>
                                        <td className="py-2 px-3 text-gray-800">{log.message}</td>
                                        <td className="py-2 px-3 text-red-500">
                                            {log.exception ? log.exception.split("\n")[0] : "-"}
                                        </td>
                                    </tr>
                                    {expandedRows[i] && log.exception && (
                                        <tr>
                                            <td colSpan={4} className="bg-orange-50 p-3 text-xs text-gray-700 font-mono whitespace-pre-wrap">
                                                {log.exception}
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={4} className="py-4 text-center text-gray-400">
                                    No logs available
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
